import * as React from 'react';
import { Ref, forwardRef } from 'react';
const SvgAttachment = (_, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    height={_.height}
    width={_.width}
    className={_.className}
    role={_.role}
    aria-label={_.ariaLabel}
    aria-hidden={_.ariaHidden}
    ref={ref}
  >
    <path
      stroke={_.color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m12.25 7.25-4.44 4.44a3 3 0 0 1-4.24 0 3 3 0 0 1 0-4.24l5.3-5.3c.78-.78 2.04-.78 2.82 0s.78 2.04 0 2.82l-5.3 5.3a.996.996 0 1 1-1.41-1.41l4.44-4.44"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgAttachment);
export default ForwardRef;
